module.exports = __webpack_public_path__ + "img/training3.d50948e1.jpeg";